import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Modal, ModalBody } from "react-bootstrap";
import NotificationHandler from '../../../../../../../../../../../utils/NotificationHandler';
import { enumUtil } from '../../../../../../../../../../../utils/Enum';
import FormValidator from '../../../../../../../../../../../utils/FormValidator';
import ModalHeader from '../../../../../../../../../../Setup/Shared/ModalHeader';
import Loader from '../../../../../../../../../../shared/Loader/Loader';
import isNull from '../../../../../../../../../../../utils/NullChecking';
import DeleteConfirmatiom from '../../../../../../../../../../General/DeleteConfirmation';
import { ServerRequestProtected } from '../../../../../../../../../../../utils/ServerDataRequest';

const AddNewFamilyHealthHistory = (props) => {
    const { isOpenFamilyHealthHistory, onClose, familyHealthHistoryData, setIsRecordSaved, patientID, IsEditAllowed, onDeleteFamilyHealthHistory } = { ...props }
    const API_URL = enumUtil.controller.General
    let FamilyHealthHistory_Modal = {
        Notes: familyHealthHistoryData.Notes || "",
    }
    
    let FamilyHealthHistory_Modal_Default = {
        Notes: "",
    }
    let valModal = {}
    let ValidationModal = {
        NotesVal: "",
    }
    const [isOpenDeleteAlert, setisOpenDeleteAlert] = useState(false);
    const [familyHealthHistoryID, setFamilyHealthHistoryID] = useState();
    const [familyHealthHistoryValidationModal, setFamilyHealthHistoryValidationModal] = useState(ValidationModal)
    const [familyHealthHistorySaveUpdateModal, setFamilyHealthHistorySaveUpdateModal] = useState({})
    const [mainFamilyHealthHistoryModal, setMainFamilyHealthHistoryModal] = useState(FamilyHealthHistory_Modal);
    const [isLoading, setIsLoading] = useState(false)
    const [onFamilyHealthHistorySaved, setOnFamilyHealthHistorySaved] = useState(false)
    const [del, setDel] = useState(false)
    const [searchDropdown, setSearchDropdown] = useState(false);
    const [is, setIs] = useState(false);

    useEffect(() => {
        // setPracticeID(PracticeID)
        if (familyHealthHistoryData.PatientHistoryID != null) {
            setDel(true)
            setFamilyHealthHistoryID(familyHealthHistoryData.PatientHistoryID)
        } else {
            if (!onFamilyHealthHistorySaved) {
                setFamilyHealthHistoryID(0);
                setDel(false)
            } else {
                setDel(true)
            }
        }
        if (!isNull(familyHealthHistoryID)) {
        }
    }, [familyHealthHistoryID])

    const FamilyHealthHistoryValidation = async () => {
        let ValidationModal = {
            NotesVal: FormValidator(
                mainFamilyHealthHistoryModal.Notes,
                enumUtil.enumValidationType.Required,
                'Notes',
            ),
        }
        await setFamilyHealthHistoryValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const addNewFamilyHealthHitory = () => {
        props.setFamilyHealthHistoryData({ PatientHistoryID: null })
        setFamilyHealthHistoryID(null)
        handleClear();
    }
    const handleSaveFamilyHealthHistory = async (type) => {
        if(!IsEditAllowed) return;
        await FamilyHealthHistoryValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            setFamilyHealthHistorySaveUpdateModal(familyHealthHistorySaveUpdateModal)
            let data = {
                PatientID: patientID,
                HistoryType: "Family Health History",
                HistorySubType: "Family Health History",
                ...familyHealthHistorySaveUpdateModal
            };

            let saveModal = {
                TableName: enumUtil.enumAPITableName.PatientHistory,
                ID: familyHealthHistoryID,
                Data: { ...data },
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
                .then((response) => {
                    if (!isNull(response.id)) {
                        setIsLoading(false)
                        NotificationHandler(`Record Saved Successfully`, enumUtil.enumtoaster.success)
                        setIsRecordSaved(true)
                        setFamilyHealthHistoryID(response.id)
                        setOnFamilyHealthHistorySaved(true);
                        if (type === "Add Another") {
                            addNewFamilyHealthHitory();
                        } else {
                            onClose();
                        }
                    }
                }).catch((error) => {
                    setIsLoading(false)
                    console.log('error', error);
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
        }
    }

    const handleClear = () => {
        setMainFamilyHealthHistoryModal(FamilyHealthHistory_Modal_Default);
        setFamilyHealthHistorySaveUpdateModal({});
    }
    const handleChange = (e) => {
        let { name, value } = e.target
        let modal = { ...mainFamilyHealthHistoryModal };
        let saveModal = { ...familyHealthHistorySaveUpdateModal }
        modal[name] = value
        setMainFamilyHealthHistoryModal(modal)
        for (var property in FamilyHealthHistory_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setFamilyHealthHistorySaveUpdateModal(saveModal)
    }

    const handleDeleteModal = () => {
        setisOpenDeleteAlert(true)
    }
    const onCloseDelete = () => {
        setisOpenDeleteAlert(false);
    }
    const onDelete = () => {
        props?.setIsRecordSaved(true);
        setisOpenDeleteAlert(false);
        onClose();
    }

    let DeleteConfirmation = "";
    if (isOpenDeleteAlert) {
        DeleteConfirmation = (
            <DeleteConfirmatiom
                isOpenAlert={isOpenDeleteAlert}
                hideReason={true}
                API_URL={API_URL}
                TableName={enumUtil.enumAPITableName.PatientHistory}
                ID={String(familyHealthHistoryID)}
                onCloseDelete={onCloseDelete}
                onClose={onDelete}
            />
        );
    }
    let DeletePopup = "";
    if (del) {
        DeletePopup = (
            <button
                className={
                    props?.IsDeleteAllowed
                      ? 
                    "btn-icon-transparent"
                      : 
                      "btn-icon-transparent delete-btn-disabled"
                } onClick={handleDeleteModal}>
                <span className="icon"><i className="icon-delete"></i></span>
                <span className="title">Delete</span>
            </button>
        );
    }

    const FamilyHealthHistoryName = () => {
        return (
            <p className="heading">Past Medical History</p>
        )
    }
    const textareaRef = useRef(null);

    const adjustTextareaHeight = () => {
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.setProperty('height', 'auto', 'important');
            textarea.style.setProperty('height', `${textarea.scrollHeight}px`, 'important');
        }
    };
    useEffect(() => {
        adjustTextareaHeight();
    }, [mainFamilyHealthHistoryModal.Notes]);
    return (
        <Modal show={isOpenFamilyHealthHistory} onHide={isOpenFamilyHealthHistory} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_ehr_problems ar_new-popup-design">
            <Modal.Body>
                {DeleteConfirmation}
                {isLoading ? <Loader /> : null}
                <ModalHeader HideAuditIcon={"PatEncounter"} HeaderName={FamilyHealthHistoryName} isOpenDeleteAlert={isOpenDeleteAlert} onCloseDelete={onCloseDelete} DeletePopup={DeletePopup} isClosed={onClose} />
                <div className="">
                    <div className='patient_payment_tabs'>
                        <div className={`input my-2 ${familyHealthHistoryValidationModal.NotesVal ? 'error' : ''}`}>
                            <label className="pb-3px">Family Health History</label>
                            <textarea
                                className="form-control overflow-hidden"
                                ref={textareaRef}
                                onInput={adjustTextareaHeight}
                                id='Notes'
                                name='Notes'
                                rows="3"
                                onChange={handleChange}
                                value={mainFamilyHealthHistoryModal.Notes}
                            />
                            {familyHealthHistoryValidationModal.NotesVal}
                        </div>
                    </div>
                </div>
            </Modal.Body>

            <div className='d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light  ar_footer justify-content-between'>
                <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={onClose}>Cancel</button>
                <div className="d-flex align-items-center gap-2">
                <button className={`btn btn-outline  px-10 h-100 validate-color ${IsEditAllowed ? '' : 'disable'}`} onClick={() => handleSaveFamilyHealthHistory("Add Another")}>Save & Add Another</button>
                <button className={`btn btn-validate px-10 h-100 ${IsEditAllowed ? '' : 'disable'}`} onClick={handleSaveFamilyHealthHistory}>Save</button>
                </div>
            </div>
        </Modal>
    )
}

export default AddNewFamilyHealthHistory